import { AppResourcePage } from '../../pages/app-resource-base';
import { constructAsync } from '../../../../webmodule-common/other/async-constructor';
import { createConcurrencyCheck, ResourceLocker } from '../../common/resource-lock';
import { customElement } from 'lit/decorators.js';
import {
  FabricationPurchaseOrderDataEntryView,
  FabricationPurchaseOrderView
} from '../../fabrication-purchase-orders/views/fabrication-purchase-order-detail-view';
import { getApiFactory } from '../../../api/api-injector';
import { goStaticURL } from '../../../../webmodule-common/other/ui/resource-resolver';
import { LangFabricationPurchaseOrder } from '../../../../localization/scripts/fabrication-purchase-orders/views/fabrication-purchase-order-lang';
import { ModalViewBase } from '../../../../webmodule-common/other/ui/data-entry-screen-base';
import { NullPromise } from '../../../../webmodule-common/interop/types/misc';

export class FabricationPurchaseOrderLock extends ResourceLocker {
  constructor(id: string, lockRevokedEvent: () => Promise<void>, concurrencyCheckEvent?: () => Promise<boolean>) {
    super(id, 'fabricationpurchaseorder', 'fabrication-purchase-order', lockRevokedEvent, concurrencyCheckEvent);
  }
}

@customElement('app-fabrication-purchase-order')
export class AppFabricationPurchaseOrderPage extends AppResourcePage {
  protected override createLock(id: string): ResourceLocker {
    const lockRevokedEvent = async () => {
      await this.view?.abandonAndClose(true);
      goStaticURL('/fabrication-purchase-orders');
    };

    const concurrencyCheck = createConcurrencyCheck(
      'FABRICATION.FABRICATIONPURCHASEORDER',
      id,
      async () => (this.view as FabricationPurchaseOrderDataEntryView | null)?.currentRecordVersion ?? ''
    );

    return new FabricationPurchaseOrderLock(id, lockRevokedEvent, concurrencyCheck);
  }

  async createModalEditor(id: string): NullPromise<ModalViewBase> {
    const result = await getApiFactory().fabricationPurchaseOrder().getPurchaseOrder({ id });
    if (!result) {
      goStaticURL('/fabrication-purchase-orders');
      return null;
    }
    return await constructAsync(
      new FabricationPurchaseOrderView({
        result,
        onClose: () => goStaticURL('/fabrication-purchase-orders'),
        isLockOwner: () => this.lock?.isLockOwner ?? false
      })
    );
  }

  meta() {
    return {
      title: () => LangFabricationPurchaseOrder.detailPageTitle(),
      description: 'Fabrication purchase order detail'
    };
  }
}
